// extracted by css-extract-rspack-plugin
export default {"cls1":"ChatInterface-cls1_CVK","cls2":"ChatInterface-cls2_7Tr ChatInterface-cls1_CVK","typing-dot":"ChatInterface-typing-dot_iuw"};